import React, { PropsWithChildren } from "react";

import MuiTypography from "@mui/material/Typography";

import { TypographyVariant } from "@/theme/components/TypographyOverrides.ts";
import { AtomProps } from "@/uiKit/atoms/utils/AtomTypes.ts";

type BaseTypographyProps = PropsWithChildren<{
  variant?: TypographyVariant;
  component?: React.ElementType;
}>;

export type TypographyProps = AtomProps<BaseTypographyProps>;

export const Typography: React.FC<TypographyProps> = ({ children, ...props }) => (
  <MuiTypography {...props}>{children}</MuiTypography>
);
